import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import Details from "./Details";
import Permissions from "./Permissions";

export default function Website(props) {
	return (
		<Container fluid className="p-0 pt-4 pb-5 mt-2 px-4 trim-padding">
			<Details {...props} />
			<Permissions {...props} />
		</Container>
	);
}
